import React, { useState, useEffect } from "react";
import { LOGIN, STUDENT } from "../../utils";
import BaseService from "../../store/services/base.service";
import {
  setKneuraId,
  setUserId,
  setInstituteKneuraId,
  setInstituteId,
  setToken,
  setusername,
  setNotificationToken,
} from "../../utils/authentication-access";
import { setTokenOnLogin } from "../../utils/api-authentication";
import { useLocation, useHistory } from "react-router-dom";
import classes from "./assessmentFull.module.css";
import CircularProgress from '@material-ui/core/CircularProgress';

const loginViaUserToken = async (userToken) => {
  const url = LOGIN.loginViaToken(userToken);
  const { data } = await new BaseService().makePostRequestGeneric(url);
  sessionStorage.clear();
  setKneuraId(data.kneura_id);
  setUserId(data.userId);
  setInstituteKneuraId(data.instituteKneuraId);
  setInstituteId(data.instituteId);
  setToken(data.access_token);
  setTokenOnLogin(data.access_token);
  setusername(data.first_name);
  setNotificationToken(data.notificationToken);

  return data;
};

const componentPath = "/assessment-list-webview";
const routePath = "/webview/learn/assessment/full/";

export const AssessmentFullWebView = () => {
  const [errorText, setErrorText] = useState("");
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const { pathname, search } = location;
    const token = new URLSearchParams(search).get("token");
    if (!token) {
      setErrorText("Invalid credentials");
      return () => {};
    }
    const pathKeys = pathname.split(routePath);
    if (pathKeys.length !== 2) {
      setErrorText("Invalid Path");
      return () => {};
    }
    const classId = pathKeys[1];

    async function login() {
      const userData = await loginViaUserToken(token, { access_token: token });

      const classFetchURL = STUDENT.getStudentClass();
      const baseService = new BaseService();
      const res = await baseService.makeGetRequestGeneric(classFetchURL, {
        role: "learner",
        institute_kneura_id: userData.instituteKneuraId,
        user_kneura_id: userData.kneura_id,
        access_token: token,
      });

      const classInfo = res.data.find((item) => item.kneuraId === classId);

      sessionStorage.setItem(
        "classinfo",
        JSON.stringify({
          ...classInfo,
        }),
      );

      history.push(componentPath);
    }

    login();
  }, [location]);

  return (
    <>
              <div className={classes.loadingGrid}>
                <CircularProgress size={50} thickness={2} />
                <div className={classes.loadingText}>Loading</div>
                <h2 style={{ color: "red" }}>{errorText}</h2>
              </div>
    </>
  );
};
